import React from "react";
import classNames from "classnames";

import { useLandingStyling } from "contexts/landingStyling";

export function LitelyticsAppDiv({ children }) {
  const isLanding = useLandingStyling();

  return (
    <div
      id="litelytics-app"
      className={classNames({
        "plus-branded-page pagewrapper-x pagewrapper-y": isLanding,
        "plus-non-branded-page": !isLanding,
      })}
    >
      {children}
    </div>
  );
}
